import { format } from 'date-fns';

const dateFormatPattern = 'yyyy-MM-dd';
const timeFormatPattern = 'HH:mm:ss';

export const formatDate = (datetime: Date): string => {
  return isNaN(datetime.getDate()) ? '' : format(datetime, dateFormatPattern);
};

export const formatTime = (datetime: Date): string => {
  return format(datetime, timeFormatPattern);
};
